<template>
  <div>
    <div class="my-info-content" v-if="settingConfig.ShowStatistics">
      <div class="my-info-header">
        <div class="warp-title">
          <img src="@/assets/img/icon06.png" style="width: 20px; margin-right: 5px;"/>
          我的信息
        </div>
        <el-popover
          placement="bottom"
          width="400"
          trigger="click"
        >
          <div>
            <div class="warp-title" style="margin-bottom: 10px;">
              <img src="@/assets/img/icon06.png" style="width: 20px; margin-right: 5px;"/>
              我的信息
            </div>
            <info-panel :line="6" :account="tenantInfo.Account" :lastLoginTime="lastLoginTime" :info="info" class="my-info-list"></info-panel>
          </div>
          <el-button type="text" slot="reference" :disabled="infoVisibleDisabled">查看详情<i class="el-icon-caret-right el-icon--right"></i></el-button>
        </el-popover>
      </div>
      <info-panel :line="2" :account="tenantInfo.Account" :lastLoginTime="lastLoginTime" :info="info" class="my-info-list" @popoverVisible="popoverVisible"></info-panel>
    </div>
    <div class="no-my-info-content" v-else>
      <span>系统管理员您好，祝您度过愉快的一天！</span>
      <div>登录于：{{lastLoginTime}}</div>
    </div>
  </div>
</template>

<script>
import InfoPanel from "@/components/InfoPanel";
import { getSentryStatement } from "@/api/module/tenant";
import { userInfoPubSub, noticeBarPubSub, settingPubSub } from "@/service/pubsub/index";
import { getLastLoginTime, getChargingPopUp } from "@/utils/service";
import { unitConvert } from "@/utils/index";

export default {
  components: {
    InfoPanel,
  },
  data() {
    return {
      info: {
        carPassInCount: 0,
        carOutCount: 0,
        lotCarNum: 0,
        chargeMessage: {
          chargeTotal: 0,
          chargeableAmountToday: 0,
          chargeMoneyToday: 0,
          abNormalChargeMoneyToday: 0,
          chargeOnlineTotal: 0,
          chargeOfflineTotal: 0,
          abnormalOrderMoney: 0,
          wxCharge: 0,
          aliCharge: 0,
          etcCharge: 0,
          actualReceiveMoney: 0,
          couponMoney: 0,
        },
      },
      time: null,
      lastLoginTime: undefined,
      chargeMessageArr: [
        {
          label: '应收',
          key: 'chargeableAmountToday',
          img: 'img12',
        },
        {
          label: '实收',
          key: 'chargeMoneyToday',
          img: 'img03',
        },
        {
          label: '微信',
          key: 'wxCharge',
          img: 'img05',
        },
        {
          label: '支付宝',
          key: 'aliCharge',
          img: 'img06',
        },
        {
          label: 'ETC',
          key: 'etcCharge',
          img: 'img07',
        },
        {
          label: '现金',
          key: 'chargeOfflineTotal',
          img: 'img04',
        },
        {
          label: '钱包',
          key: 'depositCharge',
          img: 'img11',
        },
        {
          label: '欠费',
          key: 'abNormalChargeMoneyToday',
          img: 'img13',
        },
        {
          label: '异常',
          key: 'abnormalOrderMoney',
          img: 'img14',
        },
        {
          label: '线上',
          key: 'chargeOnlineTotal',
          img: 'img15',
        },
        {
          label: '到账',
          key: 'actualReceiveMoney',
          img: 'img16',
        },
        {
          label: '优惠',
          key: 'couponMoney',
          img: 'img17',
        },
      ],
      infoVisibleDisabled: false,
    };
  },
  computed: {
    name: function () {
      return this.$route.params.GateName ? this.$route.params.GateName : "---";
    },
    parkName: function () {
      return this.$route.params.ParkLotName
        ? this.$route.params.ParkLotName
        : "XXX";
    },
    tenantInfo: function () {
      return this.$store.state.user.userInfo;
    },
    isCashier: function () {
      return this.$store.state.user.isCashier;
    },
    isSentryStatement: function () {
      return this.$store.state.user.isSentryStatement;
    },
    refreshIndex: function () {
      return this.$store.state.layout.refreshIndex;
    },
    settingConfig: function () {
      return JSON.stringify(this.$store.state.layout.settingConfig) === '{}' ? JSON.parse(getChargingPopUp()) || {ShowStatistics: false} : this.$store.state.layout.settingConfig;
    },
    noticeSortStr: function () {
      return this.$store.state.order.noticeSortStr;
    }
  },
  watch: {
    name: function () {
      this.server(false);
      this.refreshData();
    },
    isSentryStatement(v) {
      if (v) {
        this.server(false);
        this.refreshData();
      }
    },
    settingConfig() {
      setTimeout(() =>{
        this.pubNiticeBar();
      }, 100)
    },
    noticeSortStr() {
      this.pubNiticeBar();
    },
  },
  mounted() {
    this.server(false);
    // userInfoPubSub.unsubscribe();
    userInfoPubSub.subscribe(this.getInfo);
    settingPubSub.subscribe(this.pubNiticeBar);
    let refreshIndex = this.refreshIndex;
    refreshIndex++;
    this.$store.dispatch("SetRefreshIndex", refreshIndex);
    if (this.refreshIndex > 1) this.refreshData();
    this.lastLoginTime = getLastLoginTime();
  },
  beforeDestroy() {
    // sessionStorage.removeItem('refreshInfo')
    clearTimeout(this.time);
  },
  methods: {
    async server(bool) {
      // console.log('isCashier',this.isCashier, this.$store.state.user.userInfo.Id);
      const role = this.$store.state.user.userInfo.Role.RoleCode;
      const tpl = {};
      tpl.useCache = bool;
      let sentryId = this.$route.params.GateId && this.$route.params.GateId * 1 > 0
        ? this.$route.params.GateId * 1
        : undefined;
      tpl.sentryId = sentryId;
      if (role === "sentryBox") {
        tpl.tenantUserId = this.$store.state.user.userInfo.Id;
      }
      let res = await getSentryStatement(tpl);
      if (res.state === "success") {
        this.info = res.data;
        if (getChargingPopUp()) this.pubNiticeBar();
      } else {
        if (res.message.indeOf('invalid input') > -1) this.$message.error(res.message);
        if (!res.data) this.$store.dispatch("SetShowLeftSide", false);
        this.info = {
          carPassInCount: 0,
          carOutCount: 0,
          lotCarNum: 0,
          chargeMessage: {
            chargeTotal: 0,
            chargeableAmountToday: 0,
            chargeMoneyToday: 0,
            abNormalChargeMoneyToday: 0,
            chargeOnlineTotal: 0,
            chargeOfflineTotal: 0,
            wxCharge: 0,
            aliCharge: 0,
            etcCharge: 0,
            actualReceiveMoney: 0,
            couponMoney: 0,
          },
        };
      }
    },
    refreshData() {
      if (this.time) {
        clearTimeout(this.time);
      }
      this.server(true);
      this.time = setTimeout(() => {
        this.refreshData();
      }, 60000);
    },
    getInfo(data) {
      // console.log(data);
      this.info.carOutCount = data.CarOutCount;
      this.info.lotCarNum = data.LotCarNum;
      this.info.carPassInCount = data.CarPassInCount;
      this.info.chargeMessage.chargeTotal = data.ChargeTotal;
      this.info.chargeMessage.chargeableAmountToday = data.ChargeableAmountToday;
      this.info.chargeMessage.chargeMoneyToday = data.ChargeMoneyToday;
      this.info.chargeMessage.abNormalChargeMoneyToday = data.AbNormalChargeMoneyToday;
      this.info.chargeMessage.chargeOnlineTotal = data.ChargeOnlineTotal;
      this.info.chargeMessage.chargeOfflineTotal = data.ChargeOfflineTotal;
      this.info.chargeMessage.abnormalOrderMoney = data.AbnormalOrderMoney;
      this.info.chargeMessage.wxCharge = data.WxCharge;
      this.info.chargeMessage.aliCharge = data.AliCharge;
      this.info.chargeMessage.etcCharge = data.EtcCharge;
      this.info.chargeMessage.depositCharge = data.DepositCharge;
      this.info.chargeMessage.actualReceiveMoney = data.ActualReceiveMoney;
      this.info.chargeMessage.couponMoney = data.CouponMoney;
      if (data.ChargeMoneyToday !== '0.00' && data.WxCharge !== '0.00' && data.AliCharge !== '0.00' && data.EtcCharge !== '0.00' && data.ChargeOfflineTotal !== '0.00' && sessionStorage.getItem('roleCode') === 'sentryBox') {
        this.pubNiticeBar()
      }
    },
    pubNiticeBar(obj) {
//       let msg = `应收金额: <span>${this.info.chargeMessage.chargeableAmountToday}</span>
// 实收金额: <span>${this.info.chargeMessage.chargeMoneyToday}</span>
// <em class="em-arrears">欠费金额: <span>${this.info.chargeMessage.abNormalChargeMoneyToday}</span></em>
// 异常金额: <span>${this.info.chargeMessage.abnormalOrderMoney}</span>
// 现金支付: <span>${this.info.chargeMessage.chargeOfflineTotal}</span>`;
      const configArr = obj ? obj : JSON.parse(getChargingPopUp());
      let arr = configArr.SentryStatFields && configArr.SentryStatFields.map(v => {
        let itemArr = this.chargeMessageArr.filter(val => {
          return val.label === v
        });
// 线上支付: <span>${this.info.chargeMessage.chargeOnlineTotal}</span>
        return {
          name: itemArr[0].label,
          value: unitConvert(this.info.chargeMessage[itemArr[0].key])[0],
          unit: unitConvert(this.info.chargeMessage[itemArr[0].key])[1],
          img: itemArr[0].img,
        }
      });
      noticeBarPubSub.publish(arr)
    },
    popoverVisible(bool) {
      this.infoVisibleDisabled = bool;
    },
  },
};
</script>

<style lang="scss" scoped>
.my-info-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .el-button--text{
    color: #606266;
  }
}
  .my-info-content{
    background: #fff;
    padding: 20px 20px 10px;
    height: 110px;
    overflow: hidden;
  }
</style>
